import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useLang, useContent, loc, UI } from "@/lib/content";

export default function FAQ() {
  const { content } = useContent();
  const { lang } = useLang();
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="bg-paper py-24">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7 }}
          className="text-center"
        >
          <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-heritage">{loc(UI.faqHeader.overline, lang)}</p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-navy sm:text-5xl">{loc(UI.faqHeader.title, lang)}</h2>
        </motion.div>

        <div className="mt-12 divide-y divide-line border-y border-line" data-testid="faq-list">
          {content.faqs.map((f, i) => (
            <div key={i} data-testid={`faq-item-${i}`}>
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="flex w-full items-center justify-between gap-4 py-5 text-left"
              >
                <span className={`text-base font-bold transition-colors ${open === i ? "text-heritage" : "text-navy"}`}>{loc(f.q, lang)}</span>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${
                    open === i ? "rotate-45 border-heritage text-heritage" : "border-line text-mutedtext"
                  }`}
                >
                  <Plus size={15} />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <p className="pb-6 text-sm leading-relaxed text-inkbody">{loc(f.a, lang)}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
